import * as yup from 'yup';
import { Row, RenderConfig, TextInput, AssetUploadInput, ASSET_TYPE, SelectInput } from 'commons-ui';
import { STATIC_SEGMENTS_DESC_MIN_LENGTH, STATIC_SEGMENTS_SAMPLE_CSV_URL } from './constants';

export const FORM_FIELD_KEYS = {
	USE_CASE: 'useCase',
	EXP_NAME: 'expName',
	DESC: 'desc',
	CSV_URL: ASSET_TYPE.CSV
};

const USE_CASE_OPTIONS = [
	{
		id: 'coupon',
		label: 'coupon'
	},
	{
		id: 'referral',
		label: 'referral'
	}
];

export const validationSchema = yup.object().shape({
	useCase: yup.string().required('Use Case is a required field'),
	expName: yup.string().required('Segment Name is a required field'),
	desc: yup.string().required('Description is a required field'),
	csv: yup.mixed().test('file', 'Csv file is required', (file) => {
		if (file && file instanceof File && file.name.endsWith('.csv')) {
			return true;
		}
		return false;
	})
});

export const createValidationSchema = yup.object().shape({
	useCase: yup.string().required('Use Case is a required field'),
	expName: yup.string().required('Segment Name is a required field'),
	desc: yup
		.string()
		.required('Description is a required field')
		.min(STATIC_SEGMENTS_DESC_MIN_LENGTH, `description must be at least ${STATIC_SEGMENTS_DESC_MIN_LENGTH} characters long`),
	csv: yup.mixed().test('file', 'Csv file is required', (file) => {
		if (file && file instanceof File && file.name.endsWith('.csv')) {
			return true;
		}
		return false;
	})
});

export const FORM_FIELD_CONFIG = {
	[FORM_FIELD_KEYS.USE_CASE]: new RenderConfig()
		.setName('useCase')
		.setLabel('Use Case')
		.setRenderer(SelectInput)
		.setRenderProps({
			isEditable: { create: true, edit: false },
			required: true,
			options: USE_CASE_OPTIONS
		}),
	[FORM_FIELD_KEYS.EXP_NAME]: new RenderConfig()
		.setName('expName')
		.setLabel('Segment Name')
		.setRenderer(TextInput)
		.setRenderProps({ isEditable: { create: true, edit: false }, required: true }),
	[FORM_FIELD_KEYS.DESC]: new RenderConfig()
		.setName('desc')
		.setLabel('Description')
		.setRenderer(TextInput)
		.setRenderProps({ isEditable: { create: true, edit: true }, required: true }),
	[FORM_FIELD_KEYS.CSV_URL]: new RenderConfig()
		.setName(ASSET_TYPE.CSV)
		.setLabel('Upload CSV File')
		.setRenderer(AssetUploadInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			required: true,
			assetType: ASSET_TYPE.CSV,
			downloadFile: true,
			displayText: 'Sample CSV',
			link: STATIC_SEGMENTS_SAMPLE_CSV_URL
		})
};

export const FORM_LAYOUT_CONFIG = [
	new Row(FORM_FIELD_KEYS.USE_CASE),
	new Row(FORM_FIELD_KEYS.EXP_NAME),
	new Row(FORM_FIELD_KEYS.DESC),
	new Row(FORM_FIELD_KEYS.CSV_URL)
];
